import { render, staticRenderFns } from "./PdpMattressProtector.vue?vue&type=template&id=55080ffa&"
import script from "./PdpMattressProtector.vue?vue&type=script&lang=js&"
export * from "./PdpMattressProtector.vue?vue&type=script&lang=js&"
import style0 from "./PdpMattressProtector.vue?vue&type=style&index=0&id=55080ffa&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCheckbox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCheckbox.vue').default,ShopifyImage: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/ShopifyImage.vue').default})
